var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content_Library",
    "data-name": "Content Library",
    transform: "translate(-4139 -9366)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2411",
    "data-name": "Rectangle 2411",
    width: 20,
    height: 20,
    transform: "translate(4139 9366)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3077",
    "data-name": "Group 3077",
    transform: "translate(4140 9366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M112.631,102.371v11.075c-.005.013-.015.023-.015.036a1.547,1.547,0,0,1-1.579,1.351c-3.924-.008-7.845,0-11.769-.005a1.513,1.513,0,0,1-1.567-1.56V98.96a1.529,1.529,0,0,1,.013-.243A1.51,1.51,0,0,1,99.256,97.4q4.137,0,8.277,0a.261.261,0,0,1,.2.084q2.4,2.405,4.8,4.808C112.569,102.322,112.6,102.345,112.631,102.371Zm-6.22-3.72H99.29c-.253,0-.347.094-.347.35v14.234c0,.258.1.355.357.355h11.726c.258,0,.357-.1.357-.355v-9.49c0-.036,0-.071-.005-.115H107.7a1.4,1.4,0,0,1-.311-.028,1.221,1.221,0,0,1-.98-1.228c0-1.192,0-2.385,0-3.577C106.41,98.753,106.41,98.71,106.41,98.651Z",
    transform: "translate(-95.125 -94.833)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M10.3,0c.024.028.045.059.071.084.369.357.735.715,1.1,1.07.024.023.045.049.087.089H1.676a.679.679,0,0,0-.177.015.25.25,0,0,0-.2.22,1.113,1.113,0,0,0-.008.163V17.4a1.517,1.517,0,0,1-.751-.35A1.472,1.472,0,0,1,0,15.89c0-.9,0-1.795,0-2.693Q0,7.379,0,1.565A1.531,1.531,0,0,1,1.1.069C1.194.041,1.289.023,1.384,0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M224.066,464.484h-3.827a.642.642,0,0,1-.079-1.281c.04,0,.076,0,.116,0h7.573a.713.713,0,0,1,.48.148.642.642,0,0,1,.2.712.633.633,0,0,1-.6.422c-1.26,0-2.517,0-3.777,0C224.113,464.484,224.089,464.484,224.066,464.484Z",
    transform: "translate(-214.093 -451.348)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M224.051,586.384h-3.775a.739.739,0,0,1-.44-.111.641.641,0,0,1-.258-.709.653.653,0,0,1,.585-.464h7.7a.643.643,0,0,1,.1,1.281c-.055,0-.111,0-.169,0Z",
    transform: "translate(-214.084 -570.129)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M221.846,341.3c.543,0,1.083,0,1.626,0a.628.628,0,0,1,.609.509.634.634,0,0,1-.351.7.7.7,0,0,1-.282.063q-1.6.008-3.2,0a.641.641,0,1,1,0-1.281l1.595,0Z",
    transform: "translate(-214.024 -332.567)",
    fill: "current"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLibrary);
export default __webpack_public_path__ + "static/media/Content-Library.1854320c4382530551250225c8ebdc31.svg";
export { ForwardRef as ReactComponent };